import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlarmClock = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "m15.75 1.75 2.5 2.5m-3 11 2 3m-13-16.5-2.5 2.5m3 11-2 3m7-12.5v4.5h2.5m5-.25a7.25 7.25 0 1 1-14.5 0 7.25 7.25 0 0 1 14.5 0Z"
	})]
});
const ForwardRef = forwardRef(SvgAlarmClock);
export { ForwardRef as ReactComponent };
